/**
 * Shared constants and types for the Payments module.
 */

// --- Payment statuses — matches request_status enum from /v1/vip/payment-processing ---

export const PAYMENT_STATUS = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  UNDER_REVIEW: "UNDER_REVIEW",
  APPROVED: "APPROVED",
  PAYMENT_RECORDED: "PAYMENT_RECORDED",
  PAID: "PAID",
  REJECTED: "REJECTED",
} as const;

export type PaymentStatusType = (typeof PAYMENT_STATUS)[keyof typeof PAYMENT_STATUS];

export type PaymentStatusCounts = Record<string, number>;

/** Statuses where approve/reject row actions and bulk selection are available. */
export const ACTIONABLE_STATUSES = new Set<string>([
  PAYMENT_STATUS.SUBMITTED,
  PAYMENT_STATUS.UNDER_REVIEW,
]);
